module.exports = __webpack_public_path__ + "media/images/elionline/icons/side_menu_assegnare_attivo-8e3405ddab720ce8788d0911915dcd99.svg";